import React, { Component } from "react";
export class InvoiceSearch extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      fields: [
        {
          name: "school_name",
          label: "School Name",
          defaultValue: " ",
        },
        {
          name: "invoice_date",
          label: "Invoice Date",
          type: "date",
        },
        {
          name: "status",
          type: "select",
          className: "status-dropdown",
          placeholder: "Status",
          options: _enum.INVOICE_STATUS,
        },
      ]
    };
  }

  trimObjectValues(obj) {
    const trimmedObj = {};
    for (const key in obj) {
      if (typeof obj[key] === 'string') {
        trimmedObj[key] = obj[key].trim();
      } else {
        trimmedObj[key] = obj[key];
      }
    }
    return trimmedObj;
  }

  onSearch() {
    let data = this.refs.form.form.current.getData();
    // console.log("onSearch formData", data);

    data = this.trimObjectValues(data);
    data = Object.filter(data, (val) => val);
    // console.log("data on search", data);
    this.props.onSearch && this.props.onSearch(data);
  }

  clearTextData = () => {
    this.setState({
      fields: this.state.fields.map(field => ({...field, value: '' }))
    });
    let data = this.refs.form.form.current.getData();
    data = Object.filter(data, (val) => "");
    this.props.onSearch && this.props.onSearch(data);
  }  

  handleInputChange = (i, event) => {
    const newFields = [...this.state.fields];
    if(newFields[i].name != "status") newFields[i].value = event.target.value;
    this.setState({ fields: newFields });
  }

  componentDidMount() {}

  render() {
    let { fields } = this.state;

    return (
      <AppForm className="row filter-row" ref="form">
        {fields.map((field, i) => (
            <div className="col-sm-6 col-md-3" key={i}>
              <AppInputFocus {...field} onChange={event => this.handleInputChange(i, event)}></AppInputFocus>
            </div>
          ))}
        <div className="col-sm-6 col-md-3">
          <button
            className="btn btn-success btn-block w-100"
            onClick={() => this.onSearch()}
          >
            Search
          </button>
        </div>
        <span className="clear-all" onClick={() => this.clearTextData()}>Clear Filter</span>
      </AppForm>
    );
  }
}

export default connect(InvoiceSearch);
